<template>
    <div>
        <div>
            <div v-if="JSON.stringify(check_phone_data) != '{}'" class="yuyue_check_empty">
                <div v-if="check_phone_data.isp == '中国移动'">
                    <span class="iconfont iconyidong-full"></span>
                    <span style="margin-left:3px">{{ check_phone_data.isp }}</span>
                </div>
                <div v-if="check_phone_data.isp == '中国联通'">
                    <span class="iconfont iconliantong"></span>
                    <span style="margin-left:3px">{{ check_phone_data.isp }}</span>
                </div>
                <div v-if="check_phone_data.isp == '中国电信'">
                    <span class="iconfont icondianxin"></span>
                    <span style="margin-left:3px">{{ check_phone_data.isp }}</span>
                </div>

                <div class="phone_area">
                    {{ check_phone_data.area }}
                </div>
                <div v-if="check_phone_data.status == '1'" class="phone_status1"
                    :title="check_phone_msg_dict[check_phone_data.statusMsg]">
                    {{ check_phone_data.statusMsg }}
                </div>
                <div v-else class="phone_status2" :title="check_phone_msg_dict[check_phone_data.statusMsg]">
                    {{ check_phone_data.statusMsg }}
                </div>

            </div>


        </div>
    </div>
</template>

<script>
import { http } from "@/utils/http.js";
export default {
    name: 'check_phone_empty',
    data() {

        return {
            check_show: false,
            check_columns: [],
            check_data: [],
            // 
            check_phone_data: {},
            check_phone_msg_dict: {
                "实号": "即为活跃号码，误差率5-10%，出现误差原因：可能意外停机",
                "沉默号": "超过半年没有激活过的空号，或者是近三月流量均消耗低于30M",
                "空号": "空号（命中准确率100%，误差率5-10%)",
                "风险号": "属于长时间关机或未开通语音服务以及易投诉的用户",
                "停机": "里面存放着近一个月出现过的停机（命中准确率100%，误差率5-10%)。出现误差的原因，可能停机的手机号恢复使用",
                "库无": "就是数据库里面没有此号码"
            }
        }
    },
    methods: {

        open(phone) {
            var that = this;
            var obj = {
                phone: phone,
            };
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/check_empty_phone", obj, true)
                .then((res) => {
                    if (res.code == 0) {
                        console.log(res)
                        that.check_phone_data = res.data.data

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                })
                .catch((res) => {
                    console.log(res, "请求出错");
                });
        },
    }
}
</script>

<style scoped>
.phone_status1 {
    padding: 1px 5px;
    margin-left: 5px;
    color: #fff;
    background-color: #1ac101;
    border-radius: 3px;
    font-size: 12px;
    cursor: pointer;

}

.phone_status2 {
    cursor: pointer;

    margin-left: 5px;
    padding: 1px 5px;
    font-size: 12px;
    color: #fff;
    border-radius: 3px;
    background-color: #ff0000;
}

.phone_area {
    margin-left: 3px;
}

.yuyue_check_empty {
    display: flex;
    align-items: center;
    margin-left: 10px;
    font-size: 14px;
    color: #707070;
    align-items: center;
}

.iconyidong-full {
    color: #0073ff;
    font-size: 16px;
}

.iconliantong {
    color: #e4091b;
    font-size: 16px;
}

.icondianxin {
    font-size: 16px;
    color: #0073ff;
}
</style>